import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getProperty } from '@go-client/lib/api/property';
import { getUserById } from '@go-client/lib/api/user';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const GroupBookingLog: React.FC<UserActionLog> = ({ body }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        let fields = {};

        if (body.property) {
          const property = await getProperty(body.property);
          const propertyFields = FieldsReplacer(property, logFields, [
            {
              from: 'name',
              to: 'property',
            },
          ]);

          fields = { ...fields, ...propertyFields };
        }

        if (body.createdBy) {
          const user = await getUserById(body.createdBy);
          const userFields = FieldsReplacer(user, logFields, [
            {
              from: 'username',
              to: 'createdBy',
            },
          ]);

          fields = { ...fields, ...userFields };
        }

        setLogFields({ ...logFields, ...fields });
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
